import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SubscribePage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/pricing", { replace: true });
  }, [navigate]);

  return null;
};

export default SubscribePage;
